import { useMemo } from 'react';
import { useStore } from 'react-redux';
import {
  getFlowType,
  isCBandProQualifiedSession,
  getSession,
  getCheckoutExpressCart,
  isWHWP2,
  getAPPID,
  enableSelfSetup,
  getUrlName,
} from '../../../common/Helpers';
import { getPlansData, getProductRefData } from '../../../../utils/plansReference';

export const useMiniCartHooks = (isCartLoaded, isCheckoutLoaded) => {
  const existingState = useStore().getState();
  const { cartDetails: cart = {}, checkout = {}, plansReferenceData } = existingState || {};
  const showGetCheckout = getCheckoutExpressCart();
  const dueAmount = useMemo(() => {
    const { orderDetailsView = {}, dueTodayTaxes = {} } = cart?.cartDetailsJson;
    const { orderDetails = {}, lineDetails = {} } = checkout;

    const dueTodayAmount = showGetCheckout ? orderDetails?.totalDueToday : orderDetailsView?.dueTodayAmount;
    const dueMonthlyAmount = showGetCheckout
      ? lineDetails?.lineInfo?.newLine1?.serviceInfo?.totalPriceOfPlanAndPerksWithDiscounts
      : orderDetailsView?.dueMonthlyAmount;
    const dueTodayTaxAmount = showGetCheckout ? orderDetails?.totalTaxAmount : dueTodayTaxes?.[0]?.dueAmount;
    const plansReferenceVal = getPlansData(plansReferenceData);
    const planInfo = getProductRefData('dueTodayTax', 'dueTodayTax', plansReferenceVal);
    let subtitleVal;
    if (dueTodayTaxAmount && dueTodayTaxAmount === '0.0') {
      subtitleVal = planInfo?.[0]?.taxValue;
    }
    return {
      dueTodayAmount: parseFloat(dueTodayAmount) || 0,
      dueMonthlyAmount: parseFloat(dueMonthlyAmount) || 0,
      subtitleText: subtitleVal,
    };
  }, [isCartLoaded, isCheckoutLoaded]);

  return { dueAmount };
};

const getProductName = (sorId, productId, prodRefData, data) => {
  let planInfo = [];
  const plansReferenceData = getPlansData(prodRefData);
  planInfo = getProductRefData(sorId, productId, plansReferenceData);
  const flowType = getFlowType();
  let prodName;
  if (planInfo && planInfo.length > 0) {
    if (flowType === 'LTE') {
      prodName = data === 'monthly' ? planInfo[0]?.minicart_Mly_lte : planInfo[0]?.minicart_Tdy_lte;
    } else if (isCBandProQualifiedSession()) {
      prodName =
        data === 'monthly'
          ? planInfo?.[0]?.minicart_Mly_5g_CBandPro
            ? planInfo?.[0]?.minicart_Mly_5g_CBandPro
            : planInfo?.[0]?.minicart_Mly_5g
          : planInfo[0]?.minicart_Tdy_5g_CBandPro
            ? planInfo[0]?.minicart_Tdy_5g_CBandPro
            : planInfo[0]?.minicart_Tdy_5g;
    } else {
      prodName = data === 'monthly' ? planInfo[0]?.minicart_Mly_5g : planInfo[0]?.minicart_Tdy_5g;
    }
  }
  return prodName;
};

const getProductPrice = (data) => {
  const flowType = getFlowType();
  const isTgwFlow = getSession('isTGW');
  let productPrice;
  let strikedPrice;
  if (
    (flowType === 'LTE' &&
      data.cartItemType === 'DEVICE' &&
      data.totalPriceWithDiscount &&
      data.totalPriceWithDiscount === '0.0' &&
      data.discountedPrice &&
      data.discountedPrice !== '0.0') ||
    (!isWHWP2() && data.itemType && data.itemType === 'WHWBASIC' && data.totalPriceWithDiscount && data.totalPriceWithDiscount === '0.00') ||
    (isWHWP2() && data?.itemType?.includes('WHW') && parseFloat(data?.totalPriceWithDiscount).toFixed(2) === '0.00') ||
    (isWHWP2() && data.itemType && data.itemType === 'ACCESSORY' && data.bundleProductId && isTgwFlow)
  ) {
    productPrice = 'Included';
  } else if (isWHWP2() && data?.itemType?.includes('WHW') && data?.totalPriceWithDiscount !== '0.00') {
    if (data?.totalPriceWithDiscount) {
      productPrice = `$${parseFloat(data?.totalPriceWithDiscount)?.toFixed(2)}`;
    } else {
      productPrice = 'Included';
    }
  } else if (data.discountedPrice && data.discountedPrice !== '0.0' && data.totalPriceWithDiscount && data.itemPrice) {
    if (data.totalPriceWithDiscount) {
      if (data.totalPriceWithDiscount !== '0.0') {
        productPrice = `$${parseFloat(data?.totalPriceWithDiscount)?.toFixed(2)}`;
      } else {
        productPrice = 'Included';
      }
    } else {
      productPrice = `$${parseFloat(data?.discountedPrice)?.toFixed(2)}`;
      strikedPrice = `$${parseFloat(data?.itemPrice)?.toFixed(2)}`;
    }
  } else if (
    !isWHWP2() &&
    data.discountedPrice &&
    data.discountedPrice === '0.0' &&
    data.totalPriceWithDiscount &&
    data.totalPriceWithDiscount !== '0.0'
  ) {
    productPrice = `$${parseFloat(data?.totalPriceWithDiscount)?.toFixed(2)}`;
  } else {
    productPrice = 'Included';
  }
  const devicePrice = {
    prodPrice: productPrice,
    strikePrice: strikedPrice,
    quantity: data.cartItemType === 'ACCESSORY' || data.itemType === 'ACCESSORY' ? data.qty : '',
    itemType: data.cartItemType ? data.cartItemType : data.itemType,
  };
  return devicePrice;
};

const getMonthlyProductPrice = (item) => {
  const flowType = getFlowType();
  let productPrice;
  let strikedPrice;
  if (item.totalAmountWithDiscount && item.isAccountDiscount && item.isDiscountIncluded) {
    productPrice = item.totalAmountWithDiscount;
  } else if (item.totalAmountWithDiscount && (item.itemType === 'PERK' || item.itemType === 'SPO')) {
    if (parseFloat(item.totalAmountWithDiscount) !== parseFloat(item.actualAmount)) {
      strikedPrice = `$${parseFloat(item?.actualAmount)?.toFixed(2)}`;
      productPrice = `$${parseFloat(item.totalAmountWithDiscount)?.toFixed(2)}`;
    } else {
      productPrice = `$${parseFloat(item.totalAmountWithDiscount)?.toFixed(2)}`;
    }
  } else if (
    item.itemType === 'DISCOUNT' &&
    item.totalAmountWithDiscount &&
    item.name &&
    (item?.name?.startsWith('Auto') ||
      item?.name?.includes('Loyalty') ||
      item?.name?.includes('Employee') ||
      item?.name?.includes('Mobile + Home Discount'))
  ) {
    productPrice = 'Included';
  } else if (item.itemType === 'DEVICE' && Math.sign(item.totalAmountWithDiscount) === -1 && item?.downPayAmount?.downPaymentAmount > 0) {
    if (item.totalAmountWithDiscount === '0.0') {
      productPrice = 'Included';
    } else {
      productPrice = `$${Math.abs(parseFloat(item.totalAmountWithDiscount).toFixed(2))}} Credit`;
    }
  } else if (
    (flowType !== 'LTE' && item.totalAmountWithDiscount === '0.0') ||
    (isWHWP2() && item?.itemType?.includes('WHW')) ||
    (item?.isAccountDiscount === false && item.isDiscountIncluded)
  ) {
    productPrice = 'Included';
  } else {
    productPrice = `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`;
  }

  const devicePrice = {
    prodPrice: productPrice,
    strikePrice: strikedPrice,
  };
  return devicePrice;
};

export const useDueTodayListHooks = (isCartLoaded, isCheckoutLoaded) => {
  const state = useStore().getState();
  const { cartDetails: cart = {}, checkout = {}, plansReferenceData } = state || {};
  const showGetCheckout = getCheckoutExpressCart();
  const dueTodayList = useMemo(() => {
    const { cartDetailsJson = {} } = cart;
    const { lineDetails = {} } = checkout;

    const cartDetailsList = cartDetailsJson?.dueTodayList;
    const { newLine1, newLine2 } = lineDetails?.lineInfo || {};
    const checkoutList = newLine1;
    const checkoutwithhomephone = newLine2?.deviceItem;

    const dueTodayValues = [];

    if (showGetCheckout) {
      const { deviceItem, accessories } = checkoutList || {};
      if (deviceItem) {
        let prodName;
        if (deviceItem.description) {
          prodName = deviceItem.description;
        } else {
          prodName = getProductName(deviceItem?.sorId, deviceItem?.productId, plansReferenceData, 'today');
        }
        const data = {
          itemPrice: deviceItem?.itemPrice,
          discountedPrice: deviceItem?.discountedPrice,
          totalPriceWithDiscount: deviceItem?.totalPriceWithDiscount,
          itemNrpPrice: deviceItem?.itemNrpPrice,
          cartItemType: deviceItem?.cartItemType,
          itemType: deviceItem?.itemType,
          bundleProductId: deviceItem?.bundleProductId,
          qty: deviceItem?.qty,
        };
        const devicePrice = getProductPrice(data);
        dueTodayValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
          quantity: devicePrice?.quantity,
          itemType: devicePrice?.itemType,
        });
      }

      if (accessories) {
        let prodName;
        let devicePrice;
        accessories.forEach((item) => {
          if (item.description) {
            prodName = item.description;
          } else {
            prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'today');
          }
          const data = {
            itemPrice: item?.itemPrice,
            discountedPrice: item?.discountedPrice,
            totalPriceWithDiscount: item?.totalPriceWithDiscount,
            itemNrpPrice: item?.itemNrpPrice,
            cartItemType: item?.cartItemType,
            itemType: item?.itemType,
            bundleProductId: item?.bundleProductId,
            qty: item?.qty,
          };
          devicePrice = getProductPrice(data);
        });
        dueTodayValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
          quantity: devicePrice?.quantity,
          itemType: devicePrice?.itemType,
        });
      }

      if (checkoutwithhomephone) {
        let prodName;
        if (checkoutwithhomephone.description) {
          prodName = checkoutwithhomephone.description;
        } else {
          prodName = getProductName(checkoutwithhomephone?.sorId, checkoutwithhomephone?.productId, plansReferenceData, 'today');
        }
        const data = {
          itemPrice: checkoutwithhomephone?.itemPrice,
          discountedPrice: checkoutwithhomephone?.discountedPrice,
          totalPriceWithDiscount: checkoutwithhomephone?.totalPriceWithDiscount,
          itemNrpPrice: checkoutwithhomephone?.itemNrpPrice,
          cartItemType: checkoutwithhomephone?.cartItemType,
          itemType: checkoutwithhomephone?.itemType,
          bundleProductId: checkoutwithhomephone?.bundleProductId,
          qty: checkoutwithhomephone?.qty,
        };
        const devicePrice = getProductPrice(data);
        dueTodayValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
          quantity: devicePrice?.quantity,
          itemType: devicePrice?.itemType,
        });
      }
    } else if (cartDetailsList) {
      let prodName;
      let devicePrice;
      cartDetailsList.forEach((item) => {
        if (item.name) {
          prodName = item.name;
        } else {
          prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'today');
        }
        const data = {
          itemPrice: item?.actualAmount,
          discountedPrice: item?.discountApplied,
          totalPriceWithDiscount: item?.totalAmountWithDiscount,
          itemNrpPrice: item?.fullPriceDiscount,
          itemType: item?.itemType,
          bundleProductId: item?.bundleProductId,
          qty: item?.quantity,
        };
        devicePrice = getProductPrice(data);
        dueTodayValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
          quantity: devicePrice?.quantity,
          itemType: devicePrice?.itemType,
        });
      });
    }
    return {
      dueTodayValues,
    };
  }, [isCartLoaded, isCheckoutLoaded]);

  // console.log('dueTodayList output:==========' + JSON.stringify(dueTodayList));
  const dueTodayTaxList = useMemo(() => {
    const { dueTodayTaxes = {} } = cart?.cartDetailsJson;
    const { orderDetails = {} } = checkout;

    const plansReferenceVal = getPlansData(plansReferenceData);
    const planInfo = getProductRefData('dueTodayTax', 'dueTodayTax', plansReferenceVal);
    let dueTodayTaxValue;
    let dueTodayTaxAmount;
    if (dueTodayTaxes && dueTodayTaxes.length > 0) {
      dueTodayTaxValue = planInfo?.[0]?.taxText;
      dueTodayTaxAmount = showGetCheckout ? orderDetails?.totalTaxAmount : dueTodayTaxes?.[0]?.dueAmount;
    }
    const dueTodayTax = {
      displayName: dueTodayTaxValue,
      displayPrice: `$${parseFloat(dueTodayTaxAmount)?.toFixed(2)}`,
    };
    return dueTodayTax;
  }, [isCartLoaded, isCheckoutLoaded]);

  // console.log('dueTodayTax output:==========' + JSON.stringify(dueTodayTaxList));

  const dueTodayShipping = useMemo(() => {
    const { shippingDetails = {}, orderDetailsView = {} } = cart?.cartDetailsJson || {};
    const { shipping = {} } = checkout?.lineDetails?.lineInfo?.newLine1 || {};
    // how to read it from homemodel json
    const flowType = getFlowType();
    const installationType = showGetCheckout ? checkout?.depletionType : orderDetailsView?.installType;
    let showShipping = false;
    if (installationType === 'L' || installationType === 'F' || installationType?.toLowerCase().includes('self') || flowType === 'LTE') {
      showShipping = true;
    }

    let shippingName;
    let shippingCost;

    if (showGetCheckout && shipping && shipping.shippingDescription && showShipping) {
      shippingName = shipping && shipping.shippingDescription ? `${shipping.shippingDescription}` : 'Two-day shipping';
      shippingCost = shipping && shipping.shippingCost ? shipping.shippingCost : '0.00';
    } else if (shippingDetails && shippingDetails[0] && shippingDetails[0].shippingDescription && showShipping) {
      shippingName =
        shippingDetails && shippingDetails[0] && shippingDetails[0].shippingDescription
          ? `${shippingDetails[0].shippingDescription}`
          : 'Two-day shipping';
      shippingCost = shippingDetails[0] && shippingDetails[0].shippingCost ? shippingDetails[0].shippingCost : '0.00';
    }
    const pageName = getUrlName(window.location.pathname);
    const showSubText = pageName === 'cart' ? 'You can change this during checkout' : '';
    const dueTodayShippingDetails = {
      displayName: shippingName,
      displayPrice: `$${parseFloat(shippingCost)?.toFixed(2)}`,
      subtitleText: showSubText,
    };
    return dueTodayShippingDetails;
  }, [isCartLoaded, isCheckoutLoaded]);

  // console.log('dueTodayShipping output:==========' +JSON.stringify(dueTodayShipping));

  return { dueTodayList, dueTodayTaxList, dueTodayShipping };
};

export const useDueMonthlyListHooks = (isCartLoaded, isCheckoutLoaded) => {
  const state = useStore().getState();
  const { cartDetails: cart = {}, checkout = {}, plansReferenceData } = state || {};
  const showGetCheckout = getCheckoutExpressCart();
  const dueMonthlyList = useMemo(() => {
    const { cartDetailsJson = {} } = cart;
    const { lineDetails = {} } = checkout;
    const { newPricePlanInfo = {} } = lineDetails?.lineInfo?.newLine1?.serviceInfo || {};
    const { planPerks = [] } = lineDetails?.lineInfo?.newLine1?.serviceInfo || [];
    const cartDetailsList = cartDetailsJson?.dueMonthlyList;
    const dueMonthlyValues = lineDetails?.subAccountNBSInfo?.[0]?.billAccounts?.[0]?.nbs?.monthlyChargesInfo?.accountLevelCharges;

    const dueMonValues = [];

    if (showGetCheckout) {
      if (newPricePlanInfo) {
        let prodName;
        if (newPricePlanInfo?.pricePlanDisplayName) {
          prodName = newPricePlanInfo.pricePlanDisplayName;
        } else {
          prodName = getProductName(newPricePlanInfo?.sorId, newPricePlanInfo?.productId, plansReferenceData);
        }
        const data = {
          isAccountDiscount: '',
          itemType: '',
          totalAmountWithDiscount: newPricePlanInfo.planPriceWithDiscount,
          actualAmount: newPricePlanInfo.planPrice,
          name: prodName,
          downPayAmount: newPricePlanInfo.planPriceWithDiscount,
        };
        const devicePrice = getMonthlyProductPrice(data);

        dueMonValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
          // quantity: devicePrice?.quantity,
        });
      }

      if (planPerks) {
        let prodName;
        planPerks.forEach((item) => {
          if (item.featureDesc) {
            prodName = item.featureDesc;
          } else {
            prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'monthly');
          }
          const discountApplicable = item.type === 'DISCOUNT' ? true : '';
          const data = {
            isAccountDiscount: discountApplicable,
            itemType: item.type,
            totalAmountWithDiscount: item.featurePrice,
            actualAmount: item.perkOriginalPrice,
            name: prodName,
          };
          const devicePrice = getMonthlyProductPrice(data);
          dueMonValues.push({
            displayName: prodName,
            displayPrice: devicePrice?.prodPrice,
            strikedPrice: devicePrice?.strikePrice,
          });
        });
      }

      if (newPricePlanInfo && newPricePlanInfo?.planDiscountList) {
        let prodName;
        newPricePlanInfo.planDiscountList.forEach((item) => {
          if (item.description) {
            prodName = item.description;
          } else {
            prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'monthly');
          }
          const discountApplicable = item.type === 'DISCOUNT' ? true : '';
          // let planInfo = '';
          // const flowType = getFlowType();
          let discountAmountFlag;
          // if (item?.description?.startsWith('Auto') && item?.type?.includes('DISCOUNT') && flowType === 'LTE') {
          //   planInfo = getProductName('LTEAUTOPAY', '', plansReferenceData);
          // } else if (item?.description?.includes('Loyalty') && item?.type?.includes('DISCOUNT') && flowType === 'LTE') {
          //   planInfo = getProductRefData('LTELOYALTY', '', plansReferenceData);
          // }
          if (item?.accountDiscount) {
            discountAmountFlag = true;
          }

          const data = {
            isAccountDiscount: discountApplicable,
            itemType: item.type,
            totalAmountWithDiscount: item.amountOff,
            actualAmount: '',
            isDiscountIncluded: discountAmountFlag,
            name: prodName,
          };
          const devicePrice = getMonthlyProductPrice(data);

          dueMonValues.push({
            displayName: prodName,
            displayPrice: devicePrice?.prodPrice,
            strikedPrice: devicePrice?.strikePrice,
            // quantity: devicePrice?.quantity,
          });
        });
      }

      if (dueMonthlyValues) {
        let prodName;
        let devicePrice;
        dueMonthlyValues.forEach((item) => {
          if (item.description) {
            prodName = item.description;
          } else {
            prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'monthly');
          }
          const data = {
            isAccountDiscount: '',
            itemType: item.type,
            totalAmountWithDiscount: item.featurePrice,
            actualAmount: item.perkOriginalPrice,
            isDiscountIncluded: '',
            name: prodName,
          };
          devicePrice = getMonthlyProductPrice(data);
        });
        dueMonValues.push({
          displayName: prodName,
          displayPrice: devicePrice?.prodPrice,
          strikedPrice: devicePrice?.strikePrice,
        });
      }
    } else if (cartDetailsList) {
      let prodName;
      let devicePrice;
      cartDetailsList.forEach((item) => {
        if (item.name) {
          prodName = item.name;
        } else {
          prodName = getProductName(item?.sorId, item?.productId, plansReferenceData, 'monthly');
        }
        const isDiscountIncludedProp = item?.itemType?.toLowerCase()?.includes('discount');
        const data = {
          isAccountDiscount: item.isAccountDiscount,
          itemType: item.itemType,
          totalAmountWithDiscount: item.totalAmountWithDiscount,
          actualAmount: item.actualAmount,
          isDiscountIncluded: isDiscountIncludedProp,
          name: prodName,
          downPayAmount: item.totalAmountWithDiscount,
        };
        devicePrice = getMonthlyProductPrice(data);
        if (item.itemType !== 'SUBSCRIPTION') {
          dueMonValues.push({
            displayName: prodName,
            displayPrice: devicePrice?.prodPrice,
            strikedPrice: devicePrice?.strikePrice,
            quantity: devicePrice?.quantity,
          });
        }
      });
    }
    return {
      dueMonValues,
    };
  }, [isCartLoaded, isCheckoutLoaded]);
  // debugger;
  // console.log('dueMonthlyList output:==========' + JSON.stringify(dueMonthlyList));
  const dueMonthlyTaxList = useMemo(() => {
    const { orderDetailsView = {} } = cart?.cartDetailsJson;
    const { orderDetails = {} } = checkout;
    const plansReferenceVal = getPlansData(plansReferenceData);
    const planInfo = getProductRefData('dueMonthlyTaxForRedesign', 'dueMonthlyTaxForRedesign', plansReferenceVal);
    const flowType = getFlowType();
    const appId = getAPPID();
    const isSelfSetup = enableSelfSetup();
    let taxdisplayName;
    let taxSubtitleText;
    let taxIncludedText;
    if (planInfo && planInfo.length > 0 && planInfo[0]) {
      if (planInfo[0].taxName) {
        taxdisplayName = planInfo[0].taxName;
      }
      taxIncludedText = planInfo[0].taxIncluded;
      if (flowType === 'LTE') {
        // if (itemType === 'PLAN' && appId !== 'AAL' && !isSelfSetup) {
        //   taxSubtitleText = planInfoDetails[0].taxValueForPhone;
        // } else {
        taxSubtitleText = planInfo[0].taxValueLTE;
        // }
      } else if (flowType !== 'LTE') {
        taxSubtitleText = getSession('isCBandQual') === 'Y' ? planInfo[0].taxValueForTax : planInfo[0].taxValueFor5G;
      }
    }

    const taxAmount = showGetCheckout ? orderDetails?.totalMonthlyTaxes : orderDetailsView?.dueMonthlyTaxes?.dueMonthlyTaxes?.[0]?.dueAmount;

    const taxDisplayAmt =
      appId === 'AAL' && isSelfSetup ? taxIncludedText : taxAmount && taxAmount !== '0' ? `$${parseFloat(taxAmount).toFixed(2)}` : taxIncludedText;

    const dueMonTaxValue = taxdisplayName;
    const dueMonTaxAmount = taxDisplayAmt;

    const dueMonthlyTax = {
      displayName: dueMonTaxValue,
      displayPrice: dueMonTaxAmount,
      subtitleText: taxSubtitleText,
    };
    return dueMonthlyTax;
  }, [isCartLoaded, isCheckoutLoaded]);

  // console.log('dueTodayTax output:==========' + JSON.stringify(dueTodayTaxList));

  return { dueMonthlyList, dueMonthlyTaxList };
};
